import React from "react";
import {NotificationContext} from './NotificationProvider'

const withNotification = (Component: any) => (props = {}) => {
    return (
        <NotificationContext.Consumer>
            {
                context => <Component
                    {...props}
                    showNotification={context?.showNotification}
                />
            }
        </NotificationContext.Consumer>
    )
}

export default withNotification
